package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import com.schoolconnect.app.repository.systemlookup.SystemLookupOptions

@Serializable
data class EventCreateRequest(
    @SerialName("school_id") val schoolId: String,
    val title: String,
    val description: String? = null,
    @SerialName("event_date") val eventDate: String,
    val audience: String? = null,
    @SerialName("is_active") val isActive: Boolean = true,
    val status: String = SystemLookupOptions.codes("EVENT_STATUS").firstOrNull().orEmpty(),
    val id: String? = null,
    @SerialName("class_targets") val classTargets: List<String>? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String> = emptyList()
)

@Serializable
data class EventUpdateRequest(
    val title: String? = null,
    val description: String? = null,
    @SerialName("event_date") val eventDate: String? = null,
    val audience: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    val status: String? = null
    ,@SerialName("class_targets") val classTargets: List<String>? = null
)
